/**
 * Dropdown Hover Handler
 * Shows Bootstrap dropdowns on hover instead of click (desktop only)
 * On mobile, uses standard click behavior
 */

import * as bootstrap from 'bootstrap'

function initDropdownHover() {
  // Only apply hover behavior on desktop (screens wider than 992px)
  const isDesktop = () => window.innerWidth >= 992;

  const dropdownElements = document.querySelectorAll('.navbar .dropdown');

  dropdownElements.forEach(function(dropdown) {
    const dropdownToggle = dropdown.querySelector('.dropdown-toggle');
    const dropdownMenu = dropdown.querySelector('.dropdown-menu');

    if (!dropdownToggle || !dropdownMenu) return;

    let hideTimeout;
    let dropdownInstance = null;

    // Initialize Bootstrap dropdown instance
    function getOrCreateDropdown() {
      if (!dropdownInstance) {
        dropdownInstance = new bootstrap.Dropdown(dropdownToggle, {
          autoClose: true,
          // Configure Popper.js to add 18px offset
          popperConfig: {
            modifiers: [
              {
                name: 'offset',
                options: {
                  offset: [0, 11.5]
                }
              }
            ]
          }
        });
      }
      return dropdownInstance;
    }

    // Show dropdown on hover (desktop only)
    dropdown.addEventListener('mouseenter', function() {
      if (!isDesktop()) return;

      clearTimeout(hideTimeout);

      const bsDropdown = getOrCreateDropdown();
      bsDropdown.show();
    });

    // Hide dropdown when mouse leaves (desktop only)
    dropdown.addEventListener('mouseleave', function() {
      if (!isDesktop()) return;

      // Add small delay before hiding to prevent flickering
      hideTimeout = setTimeout(function() {
        if (dropdownInstance) {
          dropdownInstance.hide();
        }
      }, 150);
    });

    // Handle clicks
    dropdownToggle.addEventListener('click', function(e) {
      const bsDropdown = getOrCreateDropdown();

      if (isDesktop()) {
        // Desktop: if already shown, navigate to link; otherwise show dropdown
        if (dropdownToggle.getAttribute('aria-expanded') === 'true') {
          // Let the link navigate normally
          return true;
        } else {
          // Prevent navigation and show dropdown
          e.preventDefault();
          bsDropdown.show();
        }
      } else {
        // Mobile: toggle dropdown on click
        e.preventDefault();
        bsDropdown.toggle();
      }
    });
  });
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initDropdownHover);
} else {
  // DOM is already ready, run immediately
  initDropdownHover();
}

